import React from "react";
import { Row, Col, DatePicker } from "antd";
import moment from "moment";

const dateFormat = "MM/YY";

const CardPayment = (props) => {
  const { userData, setUserData, errorField = [], setErrorField } = props;

  // Ensure errorField is always an array
  const safeErrorField = Array.isArray(errorField) ? errorField : [];

  const handleExpirationChange = (date, dateString) => {
    if (setErrorField && safeErrorField.includes("expiration")) {
      const newErrList = safeErrorField.filter((x) => x !== "expiration");
      setErrorField([...newErrList]);
    }
    if (setUserData && userData) {
      setUserData({ ...userData, expiration: dateString });
    }
  };

  // Disable past months
  const disabledDate = (current) => {
    return current && current < moment().startOf('month');
  };

  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={24}>
          <div style={{ paddingBottom: "5px", textAlign: "left" }}>Card Number*</div>
          <div id="card-number" style={{ height: 33 }} />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: 10 }}>
        <Col xs={24} sm={12}>
          <div style={{ paddingBottom: "5px", textAlign: "left" }}>Expiration*</div>
          <DatePicker
            picker="month"
            format={dateFormat}
            placeholder="MM/YY"
            value={userData?.expiration ? moment(userData.expiration, dateFormat) : null}
            onChange={handleExpirationChange}
            disabledDate={disabledDate}
            style={{ width: "100%", height: 33 }}
            className={
              safeErrorField.includes("expiration")
                ? `common-input-error`
                : `common-input`
            }
          />
        </Col>
        <Col xs={24} sm={12}>
          <div style={{ paddingBottom: "5px", textAlign: "left" }}>CVV</div>
          <div id="card-cvv" style={{ height: 33 }} />
        </Col>
      </Row>
    </>
  );
};

export default CardPayment;
